export default __webpack_public_path__ + "static/running-lean-825b3aa4b13c8aec0acc4d115e63f31d.jpg";